import brickTypes from './brick-types';
import getResource from "../../../Util/resources";
import displayFormats from './brick-display-formats';

const createBrickDefinition = (name, type, displayNameResource, icon, displayFormat) => {
    return {
        name: name,
        type: type,
        icon: icon,
        displayFormat: displayFormat,
        get displayName() { 
            //Resources are not expected to be available on import
            return getResource(displayNameResource);
        }
    };
};

const brickDefinitions = {
    [brickTypes.audience]: createBrickDefinition(
        'audience',
        brickTypes.audience,
        'JourneyComposerBrickType_Audience_DisplayName',
        'fas fa-user-friends',
        displayFormats.square
    ),
    [brickTypes.journey]: createBrickDefinition(
        'journey',
        brickTypes.journey,
        'JourneyComposerBrickType_Journey_DisplayName',
        'fas fa-route',
        displayFormats.square
    ),
    [brickTypes.touchpoint]: createBrickDefinition(
        'touchpoint',
        brickTypes.touchpoint,
        'JourneyComposerBrickType_Touchpoint_DisplayName',
        'fas fa-hand-point-right',
        displayFormats.square
    ),
    [brickTypes.audienceFilter]: createBrickDefinition(
        'audienceFilter',
        brickTypes.audienceFilter,
        'JourneyComposerBrickType_AudienceFilter_DisplayName',
        'fas fa-map-signs',
        displayFormats.octagon
    )
};

const brickDefinitionsArray = Object.values(brickDefinitions);

export {
    brickDefinitions,
    brickDefinitionsArray
};
